import { render, staticRenderFns } from "./CreateView.vue?vue&type=template&id=336fc371&scoped=true"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"
import style0 from "./CreateView.vue?vue&type=style&index=0&id=336fc371&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fc371",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('336fc371')) {
      api.createRecord('336fc371', component.options)
    } else {
      api.reload('336fc371', component.options)
    }
    module.hot.accept("./CreateView.vue?vue&type=template&id=336fc371&scoped=true", function () {
      api.rerender('336fc371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateView.vue"
export default component.exports